import { render, staticRenderFns } from "./modal-participant.vue?vue&type=template&id=25159fad&scoped=true"
import script from "./modal-participant.vue?vue&type=script&lang=js"
export * from "./modal-participant.vue?vue&type=script&lang=js"
import style0 from "./modal-participant.vue?vue&type=style&index=0&id=25159fad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25159fad",
  null
  
)

export default component.exports